import { Box, Stack, styled, Typography, Link } from '@mui/material';

export const ModalBox = styled(Box)(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    background: '#fff',
    [theme.breakpoints.up('xs')]: {
        width: '310px',
        height: 'auto',
        maxHeight: 'calc(100% - 3.5rem)'
    },
    [theme.breakpoints.up('sm')]: {
        width: '600px',
        height: 'auto',
        maxHeight: 'calc(100% - 3.5rem)'
    },
    [theme.breakpoints.up('md')]: {
        width: '100%',
        height: 'auto',
        maxHeight: 'calc(100% - 3.5rem)'
    },
    border: '1px solid #dfdfdf',
    display: 'flex',
    flexDirection: 'column'
}));

export const BodyContainer = styled(Box)(() => ({
    padding: '18px',
    flexGrow: 3,
    height: '100%',
    overflow: 'auto'
}));

export const HeaderContainer = styled(Box)(() => ({
    padding: '18px',
    position: 'relative',
    borderBottom: '1px solid #e9e9e9',
    flexGrow: 1
}));

export const IconContainer = styled(Box)(() => ({
    position: 'absolute',
    right: '1rem',
    top: '0.5rem',
    cursor: 'pointer'
}));

export const FooterContainer = styled(Stack)(() => ({
    borderTop: '1px solid #e9e9e9',
    padding: '1rem',
    flexGrow: 1
}));

export const StyledLabel = styled(Typography)({
    fontStyle: 'italic',
    fontWeight: '300',
    fontSize: '12px',
    // lineHeight: '0px',
    letterSpacing: '0.05em',
    color: '#393939'
});

export const StyledValue = styled(Typography)({
    fontWeight: '600',
    fontSize: '16px',
    lineHeight: '20px',
    letterSpacing: '0.05em',
    color: '#555555'
});

export const StyledValueForParagraph = styled(Typography)({
    fontWeight: '600',
    fontSize: '16px',
    lineHeight: '20px',
    letterSpacing: '0.05em',
    color: '#555555',
    whiteSpace: 'pre-line',
    fontStyle: 'initial'
});

export const StyledTableLink = styled(Link)(() => ({
    textDecoration: 'none',
    cursor: 'pointer',
    fontStyle: 'italic',
    fontWeight: '300',
    fontSize: '12px',
    // lineHeight: '0px',
    letterSpacing: '0.05em'
}));
